import React, { memo } from "react";
import CommunicationTimeline from "./CommunicationTimeline";

const Index = () => {
  return <CommunicationTimeline />;
};

export default memo(Index);
